<template>
  <div>
    <h4 class="text-center">
      Personne n'est venu à cette réunion. Sélectionnez ce que vous aimeriez faire ensuite
    </h4>
    <div class="d-flex justify-content-around my-3">
      <b-button variant="light" @click="generatePvPdf">
        <font-awesome-icon icon="file-pdf" />
        <span class="pl-2">Procès verbal</span>
      </b-button>
      <b-button variant="light" @click="generatePresencePdf">
        <i class="fa fa-meetup" aria-hidden="true"></i>
        <font-awesome-icon icon="file-pdf" />
        <span class="pl-2">Feuille de présence</span>
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    generatePvPdf() {
      this.$emit("generatePvPdf");
    },
    generatePresencePdf() {
      this.$emit("generatePresencePdf");
    },
  },
};
</script>
